<div class="role-home">
  <div class="role-home__content">
    <div class="role-home__header">
      <div>
        <h1 class="page-title">Roles</h1>
        <p class="page-subtitle">Define roles and manage permissions across the system.</p>
      </div>
    </div>

    <app-table
      [data]="roleState.data()"
      [columns]="roleColumns"
      [config]="roleConfig"
      [pagination]="rolePagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-table>
  </div>
</div>
